import React, { useState, useEffect } from "react";
import { Container, Col, Row, Form } from "react-bootstrap";
import API_DOMAIN from "../config/config";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { TableUI } from "../components/Tables";
import { TextInputForm } from "../components/Forms";

import { ClickButton } from "../components/Buttons";
import { useNavigate } from "react-router-dom";

import { PageTitle } from "../components/PageTitle";

const UserTablehead = ["No", "StaffName", "Role","Advance Amount","Action"];

const Staff = () => {
  const navigate = useNavigate();

  const [userData, setUserData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/staff.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "listStaff", // Specify the action you're performing
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      if (responseData.head.code === 200) {
        setUserData(responseData.body.staff); // Store original data
        setFilteredData(responseData.body.staff); // Set filtered data initially to all staff
      } else {
        throw new Error(responseData.head.msg || "Unknown error");
      }
    } catch (error) {
    }
  };

  const handleSearch = (value) => {


    if (value === "") {
      setFilteredData(userData); // If search is empty, show all staff
    } else {
      const filtered = userData.filter((staff) => {
        // Ensure both staff_name and mobile_number are treated as strings
        const staffName = staff.staff_name.toLowerCase();
        const staffMobile = String(staff.mobile_number).toLowerCase(); // Convert mobile number to string
        return (
          staffName.includes(value.toLowerCase()) || staffMobile.includes(value)
        );
      });
      setFilteredData(filtered); // Filter the data based on staff name or mobile number
    }
  };


  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid>
        <Row>
          <Col lg="12" className="py-3">
            <div className="main my-3">
              <Row className="mx-2">
                <Col lg="12" md="12" xs="12" className="align-self-center">
                  <PageTitle PageTitle={"Staff"} />
                </Col>
                <Col lg="3">
                  <div className=" mx-2">
                    {/* <Buttons lable={<>Filter</>} onClick={showFilter} /> */}
                    <TextInputForm
                      placeholder={"Name"}
                      onChange={(e) => handleSearch(e.target.value)}
                      prefix_icon={<FaMagnifyingGlass />}
                      labelname={"Search"}
                    >
                      {" "}
                    </TextInputForm>
                  </div>
                </Col>
                <Col
                  lg="9"
                  className="d-flex align-item-baseline justify-content-end"
                >
                  <div className="text-end">
                    <ClickButton
                      label="Add New"
                      onClick={() => navigate("/console/staff/create")}
                    />
                  </div>
                </Col>
              </Row>
              <div className="py-2 ">
                <TableUI
                  headers={UserTablehead}
                  body={filteredData}
                  pageview={"yes"}
                  type="staff"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Staff;

